// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyD_D_SLzRWLDUE8q7vSfNGrtz_F6F590Yo",
  authDomain: "tipper-9a9ca.firebaseapp.com",
  projectId: "tipper-9a9ca",
  storageBucket: "tipper-9a9ca.appspot.com",
  messagingSenderId: "803573495791",
  appId: "1:803573495791:web:d80f5e749e2e86a182e81a",
  measurementId: "G-XR9HEKE89N",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
export const firestore = getFirestore(app);
